// extracted by mini-css-extract-plugin
export default {"topic":"index_topic_N-gCw","newsinfo":"index_newsinfo_udFr0","endnews":"index_endnews_R6LfL"};